/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TeamsControllerFindOneQueryResponse, TeamsControllerFindOnePathParams, TeamsControllerFindOneQueryParams, TeamsControllerFindOne400, TeamsControllerFindOne401, TeamsControllerFindOne403, TeamsControllerFindOne404 } from "../../models/teamsController/TeamsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { teamsControllerFindOne } from "../../clients/teamsService/teamsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const teamsControllerFindOneQueryKey = (id: TeamsControllerFindOnePathParams["id"], params: TeamsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/teams/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type TeamsControllerFindOneQueryKey = ReturnType<typeof teamsControllerFindOneQueryKey>;
export function teamsControllerFindOneQueryOptions(id: TeamsControllerFindOnePathParams["id"], params?: TeamsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = teamsControllerFindOneQueryKey(id, params);
  return queryOptions<TeamsControllerFindOneQueryResponse, ResponseErrorConfig<TeamsControllerFindOne400 | TeamsControllerFindOne401 | TeamsControllerFindOne403 | TeamsControllerFindOne404>, TeamsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return teamsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get team by id
 * {@link /api/v1/teams/:id}
 */
export function useTeamsControllerFindOne<TData = TeamsControllerFindOneQueryResponse, TQueryData = TeamsControllerFindOneQueryResponse, TQueryKey extends QueryKey = TeamsControllerFindOneQueryKey>(id: TeamsControllerFindOnePathParams["id"], params?: TeamsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<TeamsControllerFindOneQueryResponse, ResponseErrorConfig<TeamsControllerFindOne400 | TeamsControllerFindOne401 | TeamsControllerFindOne403 | TeamsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? teamsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...teamsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TeamsControllerFindOne400 | TeamsControllerFindOne401 | TeamsControllerFindOne403 | TeamsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}